/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Events_Imported_ToastInputs */

const en_ocr_events_imported_toast = /** @type {(inputs: Ocr_Events_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR results imported as event group.`)
};

const fr_ocr_events_imported_toast = /** @type {(inputs: Ocr_Events_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résultats de la reconnaissance optique de caractères (OCR) importés en tant que groupe d'événements.`)
};

const de_ocr_events_imported_toast = /** @type {(inputs: Ocr_Events_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR-Ergebnisse wurden als Ereignisgruppe importiert.`)
};

const it_ocr_events_imported_toast = /** @type {(inputs: Ocr_Events_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I risultati dell'OCR sono stati importati come gruppo di eventi.`)
};

const ru_ocr_events_imported_toast = /** @type {(inputs: Ocr_Events_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результаты распознавания текста импортированы как группа событий.`)
};

const es_ocr_events_imported_toast = /** @type {(inputs: Ocr_Events_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los resultados del OCR se importaron como grupo de eventos.`)
};

const zh_cn2_ocr_events_imported_toast = /** @type {(inputs: Ocr_Events_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR结果以事件组的形式导入。`)
};

const ja_ocr_events_imported_toast = /** @type {(inputs: Ocr_Events_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCRの結果はイベントグループとしてインポートされます。`)
};

const hi_ocr_events_imported_toast = /** @type {(inputs: Ocr_Events_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR परिणामों को इवेंट समूह के रूप में आयात किया गया।`)
};

const pt_pt2_ocr_events_imported_toast = /** @type {(inputs: Ocr_Events_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados de OCR importados como grupo de eventos.`)
};

/**
* | output |
* | --- |
* | "OCR results imported as event group." |
*
* @param {Ocr_Events_Imported_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_events_imported_toast = /** @type {((inputs?: Ocr_Events_Imported_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Events_Imported_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_events_imported_toast(inputs)
	if (locale === "de") return de_ocr_events_imported_toast(inputs)
	if (locale === "it") return it_ocr_events_imported_toast(inputs)
	if (locale === "ru") return ru_ocr_events_imported_toast(inputs)
	if (locale === "es") return es_ocr_events_imported_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_events_imported_toast(inputs)
	if (locale === "ja") return ja_ocr_events_imported_toast(inputs)
	if (locale === "hi") return hi_ocr_events_imported_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_events_imported_toast(inputs)
	return en_ocr_events_imported_toast(inputs)
});